import { assets } from '@/ui/assets'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { Tooltip, TooltipContent, TooltipContentLayout, TooltipTrigger } from '@/ui/atoms/tooltip/Tooltip'
import { links } from '@/ui/constants/links'
import { cn } from '@/ui/utils/style'
import { testIds } from '@/ui/utils/testIds'

export function AutomatedMarketBadge({ className }: { className?: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          className={cn(
            'rounded-full bg-[linear-gradient(270deg,rgba(173,0,196,0.10)_-7.95%,rgba(255,99,208,0.10)_99.99%)] py-1 pr-2 pl-1.5',
            'hover:bg-[linear-gradient(270deg,rgba(173,0,196,0.15)_-7.95%,rgba(255,99,208,0.15)_99.99%)]',
            'flex items-center gap-1',
            className,
          )}
          data-testid={testIds.markets.sllManagedPill}
        >
          <img src={assets.brand.sparkLiquidityLayer} alt="Automated Market" className="size-3" />
          <div
            className={cn(
              'typography-label-4 xl:typography-label-3 bg-clip-text text-transparent',
              'bg-[linear-gradient(270deg,#AD00C4_-7.95%,#FF63D0_115.29%)]',
            )}
          >
            Automated
          </div>
        </button>
      </TooltipTrigger>
      <TooltipContent variant="long">
        <TooltipContentLayout>
          <TooltipContentLayout.Header>
            <TooltipContentLayout.Icon src={assets.brand.sparkLiquidityLayer} />
            <TooltipContentLayout.Title>Automated by SLL</TooltipContentLayout.Title>
          </TooltipContentLayout.Header>
          <TooltipContentLayout.Body>
            This market is automated by the Spark Liquidity Layer. More liquidity will be added as you borrow to
            maintain the borrow rate.{' '}
            <ExternalLink to={links.docs.sparkLiquidityLayer} variant="secondary">
              Learn more
            </ExternalLink>
          </TooltipContentLayout.Body>
        </TooltipContentLayout>
      </TooltipContent>
    </Tooltip>
  )
}
